import { get } from 'lodash'

import { checkHostnames } from '@sigma-frontend-libs/commons'

import { developmentHostnames, imlinkHostnames, jivositeRoistatHostnames } from '@/utils'

export default function(h) {
  if (checkHostnames(developmentHostnames)) {
    return
  }

  if (checkHostnames(imlinkHostnames)) {
    return
  }

  const jivositeId = get(this.globalSettings, 'frontend.jivosite')
  if (jivositeId) {
    const toggleVisibility = show => {
      const container = document.querySelector('jdiv')
      if (container) {
        if (!show) {
          container.classList.add('jivo-override')
        } else {
          container.classList.remove('jivo-override')
        }
      }
    }

    return h(
      'script',
      {
        attrs: {
          type: 'text/javascript',
          async: true,
          src: '//code.jivosite.com/widget.js',
          'data-jv-id': jivositeId
        },
        on: {
          load: async () => {
            let jivoApiReadyAttempts = 0
            while (!window.jivo_api && jivoApiReadyAttempts < 200) {
              await new Promise(resolve => {
                return setTimeout(resolve, 100)
              })
              jivoApiReadyAttempts += 1
            }

            if (!window.jivo_api) {
              return
            }

            toggleVisibility(false)
            const closeButton = document.getElementById('jivo_close_button')
            if (closeButton) {
              closeButton.addEventListener('click', () => {
                toggleVisibility(false)
              })
            }

            window.jivo_onOpen = () => {
              const accountData = get(this, 'account.data', {})
              window.jivo_api.setContactInfo({
                name: accountData.firstName || '',
                email: accountData.email || '',
                phone: accountData.phone || ''
              })

              toggleVisibility(true)
            }

            const getCookie = window.getCookie = name => {
              const matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'))

              if (matches) {
                return decodeURIComponent(matches[1])
              }

              return 'nocookie'
            }

            const applyRoistatIntegration = () => {
              if (!checkHostnames(jivositeRoistatHostnames)) {
                return
              }

              const visit = getCookie('roistat_visit')
              switch (visit) {
                case 'nocookie': {
                  window.onRoistatAllModulesLoaded = function() {
                    window.roistat.registerOnVisitProcessedCallback(function() {
                      window.jivo_api.setUserToken(window.roistat.getVisit())
                    })
                  }
                  break
                }
                default: {
                  window.jivo_api.setUserToken(visit)
                  break
                }
              }
            }

            window.jivo_onLoadCallback = function() {
              toggleVisibility(false)
              applyRoistatIntegration()
            }
          }
        }
      }
    )
  }
}
